import React from "react";
import { useState, useEffect } from "react";
import { ReactComponent as Logo } from "../assets/images/logoSmall.svg";
import { ReactComponent as BurgerIcon } from "./assets/burger.svg";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";
import { ReactComponent as SubmenuIcon } from "./assets/header-submenu.svg";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useMediaQuery from "@mui/material/useMediaQuery";
import style from "./block.module.scss";
import clsx from "clsx";
import { BlockWrapper } from "@smartfire/js-block-engine";

function Block({ homeUrl, menu, languages, contactUrl, secondaryMeny }) {
  const [isOpen, setOpen] = useState(false);
  const [openLang, setOpenLang] = useState(false);
  const isTablet = useMediaQuery("(max-width: " + style.tabletBreakpoint + ")");
  const handleOpen = () => {
    if (isOpen) {
      document.body.style.removeProperty("overflow");
    } else {
      document.body.style.overflow = "hidden";
    }

    setOpen(!isOpen);
  };

  useEffect(() => {
    setOpen(false);
  }, [isTablet]);

  const currentUrl = window.location.href;

  return (
    <BlockWrapper.Div
      className={clsx(style.block, isTablet && style.tabletHeader)}
    >
      {!isTablet && (
        <div className={style.logo}>
          <a href="/">
            <Logo />
          </a>
        </div>
      )}

      {isTablet && (
        <div className={style.tabletMenu}>
          <a href={homeUrl}>
            <Logo />
          </a>

          <BurgerIcon className={style.btnMenu} onClick={handleOpen} />
        </div>
      )}

      <div className={clsx(style.wrapMenu, isTablet && isOpen && style.isOpen)}>
        {isTablet && (
          <div className={style.closeIconContainer}>
            <CloseIcon className={style.btnMenu} onClick={handleOpen} />
          </div>
        )}
        <ul className={clsx(style.menu, isTablet && style.menuTablet)}>
          {menu &&
            Object.values(menu).map((item) => {
              const hasChildren = Object.values(item.children).length > 0;
              return (
                <li
                  key={item.ID}
                  className={clsx(style.el, hasChildren && style.hasChildren)}
                >
                  {!isTablet ? (
                    <>
                      {item.url && item.url !== "#" ? (
                        <a
                          href={item.url}
                          className={clsx(
                            item.url === currentUrl && style.current
                          )}
                        >
                          {item.title}
                          {hasChildren && <SubmenuIcon />}
                        </a>
                      ) : (
                        <p
                          className={clsx(
                            item.url === currentUrl && style.current
                          )}
                        >
                          {item.title}
                          {hasChildren && <SubmenuIcon />}
                        </p>
                      )}
                      <div className={style.subMenuContainer}>
                        <ul className={style.subMenu}>
                          {item.children.map((subItem, index) => (
                            <li
                              key={"subMenu-" + index}
                              className={style.subMenuItem}
                            >
                              <a
                                href={subItem.url}
                                className={clsx(
                                  subItem.url === currentUrl && style.current
                                )}
                              >
                                {subItem.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      {hasChildren ? (
                        <>
                          <Accordion className={style.accordionMobile}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              {item.url && item.url !== "#" ? (
                                <a href={item.url} title={item.title}>
                                  {item.title}
                                </a>
                              ) : (
                                <p>{item.title}</p>
                              )}
                            </AccordionSummary>
                            <AccordionDetails>
                              <ul className={style.accordionMenu}>
                                {item.children.map((subItem, index) => (
                                  <li
                                    key={index}
                                    className={style.AccordionmenuItem}
                                  >
                                    <a href={subItem.url} title={subItem.title}>
                                      {subItem.title}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </AccordionDetails>
                          </Accordion>
                        </>
                      ) : (
                        <a href={item.url}>{item.title}</a>
                      )}
                    </>
                  )}
                </li>
              );
            })}
          <li className={style.contactButton}>
            <a href={contactUrl}>Contact</a>
          </li>
          {Object.keys(languages).length > 1 && (
            <li className={clsx(style.languages, openLang && style.open)}>
              <ul>
                <ArrowIcon
                  className={style.arrow}
                  onClick={() => setOpenLang(!openLang)}
                />
                {languages &&
                  Object.keys(languages).map((lang, i) => (
                    <li
                      key={i}
                      className={clsx(
                        style.lang,
                        languages[lang].active && style.active
                      )}
                    >
                      <a
                        href={
                          languages[lang].active ? false : languages[lang].url
                        }
                      >
                        <img
                          src={languages[lang].country_flag_url}
                          alt={languages[lang].code}
                        />
                        {languages[lang].code}
                      </a>
                    </li>
                  ))}
              </ul>
            </li>
          )}
        </ul>
      </div>
    </BlockWrapper.Div>
  );
}

export default Block;
